import {TUrlImportItem} from "./types";

export const sortUrls = (urls: TUrlImportItem[]) => {
	const statusPriority: {[key: string]: number} = {
		// In-progress statuses come first
		waiting: 1,
		importing: 1,
		scraping: 1,
		"in progress": 1,
		created: 1,
		scraped: 1,
		// Success statuses come second
		success: 2,
		imported: 2,
		completed: 2,
		"already exists": 2,
		// Error statuses come last
		"scraping error": 3,
		"import error": 4,
		"not found": 5,
		"bad url": 6,
	};

	if (!urls) return [];

	// Step 1: Filter duplicates by keeping the highest priority status
	const uniqueUrls: {[url: string]: TUrlImportItem} = {};

	urls.forEach((url) => {
		const status = url.status?.toLowerCase();
		const priority = statusPriority[status] || 3;

		// If URL is not in the map or the current status has a higher priority, update the map
		if (
			!uniqueUrls[url.url] ||
			(uniqueUrls[url.url] &&
				priority < statusPriority[uniqueUrls[url.url].status.toLowerCase()])
		) {
			uniqueUrls[url.url] = url;
		}
	});

	// Step 2: Convert the map back to an array and sort by status priority
	// Order: in-progress on top, success next, errors at the bottom
	return Object.values(uniqueUrls).sort((a, b) => {
		const priorityA = statusPriority[a.status.toLowerCase()] || 3;
		const priorityB = statusPriority[b.status.toLowerCase()] || 3;

		return priorityA - priorityB;
	});
};
